import { Commerce, CommerceFilters, MeliSellerListItem } from '../models';

export type MeliSellersByCommerceCode = Record<string, MeliSellerListItem[]>;

/** Código con el que meli integra vincula al comercio: el api_code o, si no tiene, el external_id. */
export const getCommerceIntegrationCode = (
  commerce: Pick<Commerce, 'apiCode' | 'externalId'>
): string => commerce.apiCode?.trim() || commerce.externalId?.trim() || '';

export const formatCommerceAddress = (
  commerce: Pick<Commerce, 'address'>
): string => {
  const address = commerce.address;
  if (!address) return '';
  const street = [address.streetName, address.doorNumber]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
  const apartment = address.apartmentNumber?.trim();
  return apartment ? `${street}, ${apartment}` : street;
};

export const getCommerceCity = (commerce: Pick<Commerce, 'address'>): string =>
  commerce.address?.neighborhood?.city?.name?.trim() ?? '';

/**
 * Seller ID de Mercado Libre del comercio: los activos, y si no tiene ninguno
 * activo, los inactivos marcados como tales.
 */
export const formatCommerceSellerIds = (
  sellers: MeliSellerListItem[] = []
): string => {
  const active = sellers.filter((seller) => seller.isActive);
  if (active.length > 0) return active.map((seller) => seller.id).join(', ');
  return sellers.map((seller) => `${seller.id} (inactivo)`).join(', ');
};

/** Códigos de los comercios vinculados a algún seller cuyo ID contiene el buscado. */
export const findCommerceCodesBySellerId = (
  sellersByCode: MeliSellersByCommerceCode,
  sellerId: string
): string[] =>
  Object.entries(sellersByCode)
    .filter(([, sellers]) =>
      sellers.some((seller) => String(seller.id).includes(sellerId))
    )
    .map(([code]) => code);

/**
 * Filtros tal como los pide el back: el Seller ID de ML se cambia por los
 * códigos de los comercios vinculados. Sin ningún comercio vinculado la lista
 * va vacía y el back no devuelve nada.
 */
export const toCommerceQueryFilters = (
  { sellerId, ...filters }: CommerceFilters,
  sellersByCode: MeliSellersByCommerceCode
): CommerceFilters => {
  const trimmedSellerId = sellerId?.trim();
  if (!trimmedSellerId) return filters;
  return {
    ...filters,
    integrationCodes: findCommerceCodesBySellerId(
      sellersByCode,
      trimmedSellerId
    ),
  };
};
